


























































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import FieldArea from "@/models/coding/fieldArea/fieldAreaModel";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from '../../../enums/PermissionValue';
@Component
export default class FieldAreaTable extends GenericBTable<FieldArea> {
  isLoading = false;
  created() {
    this.permissionValue = PermissionValue.CODIFICACIONES;
    this.tableConfig.controller = "FieldAreas";
      this.tableConfig.whereParams = `areaId eq ${
      this.$route.params.areaId
    }`; 
    this.formatColumns();
  }
  formatColumns() {
   let name = new BTableColumn("name", "table.name", false);
    let code = new BTableColumn("code", "table.code", true);
    this.tableConfig.insertColumns(name,code);
    this.tableConfig.actions.customTemplate = true;
  }
  verOpciones(row: FieldArea) {
   
    this.$router.push(`/Area/${row.areaId}/FieldArea/${row.id}/ResearchLine`);
  }
}
